import { useOutletContext } from "@remix-run/react";
import { useState } from "react";
import { ModalWithOverlay } from "~/components/Modal";
import { StoreLoaderContext } from "~/entities/global/types";
import BusinessSurvey from "./BusinessSurvey";
import CreateAccount from "./CreateAccount";
import MemberSurvey from "./MemberSurvey";

const CreateAccountWizard: React.FC = () => {
  const [step, setStep] = useState<string>("create_account");
  const context = useOutletContext<StoreLoaderContext>();

  return (
    <ModalWithOverlay isOpen={context?.createAccountWizardOpen}>
      <div className="w-full max-w-[500px] flex flex-col rounded-none bg-white px-2 pb-8 pt-2 font-sans shadow-lg md:border md:border-black">
        <CreateAccount
          onSuccess={(customerType) => setStep(`${customerType}_survey`)}
          isActive={step === "create_account"}
        />
        <BusinessSurvey
          onSuccess={() => setStep("business_profile")}
          isActive={step === "business_survey"}
        />
        <MemberSurvey
          onSuccess={() => setStep("member_profile")}
          isActive={step === "member_survey"}
        />
      </div>
    </ModalWithOverlay>
  );
};

export default CreateAccountWizard;
